<nav class="navbar navbar-expand-sm bg-light">
  <ul class="navbar-nav">
    <li class="nav-item logoImage min-width-205"><a class='nav-link' [routerLink]="['/upload']"></a></li>
    <li class="nav-item"><a class='nav-link' [routerLink]="['/upload']">Upload File</a></li>
    <li class="nav-item"><a class='nav-link' [routerLink]="['/report']">Report</a></li>
    <li class="nav-item"><a class='nav-link' [routerLink]="['/user-management']"
                            *ngIf="userRole=='ROLE_PARTNER_ADMIN'  || userRole=='ROLE_SUPER_ADMIN'">Users Management</a></li>
  </ul>
  <ul class="nav navbar-nav ms-auto">
    <li class="nav-item"><a class='nav-link' [routerLink]="[]" (click)='LogOut()'>Log Out</a></li>
  </ul>
</nav>
<div class='container-router-outlet'>
  <router-outlet></router-outlet>
</div>
